__turbopack_context__.v({
  "giscus-container": "RdmvxW_giscus-container",
});
